export default {
    ACCOUNT: '/account',
    ACTIVITY: '/activity',
    ANALYSIS_REQUEST: '/analysis/request',
    API_KEYS: '/api-keys',
    ASK_ANALYST: '/ask-analyst',
    ASSESSMENTS: '/assessments',
    ASSESSMENTS_REPORTING: '/assessments/reporting',
    ASSESSMENT_ASSIGNMENTS: '/assessments/assignment',
    ASSESSMENT_PROJECTS: '/assessments/projects',
    ASSESSMENT_TEMPLATES: '/assessments/templates',
    BREACHES: '/breaches',
    COMPLIANCE_CHECK_SITES: '/compliance-check/sites',
    CONNECT_DATA_MAPPING: '/connect/data-mapping',
    CONNECT_OAUTH: '/connect',
    CONNECT_UC_INTEGRATION: '/connect/uc-integration',
    CONSENT: '/consent',
    CONSENT_DASHBOARD: '/consent/dashboard',
    CONSENT_MANAGER: '/consent/banners',
    CONSENT_MONITOR: '/consent-monitor',
    CONSUMER_SSO: '/unified-consent/consumer-sso', // path should be updated when Consumer SSO is product-agnostic
    CUSTOMER: '/customer',
    DASHBOARD: '/dashboard',
    DATA_MAP: '/discovery/map',
    DATA_MAPPING_APPLICATIONS: '/discovery/applications',
    DATA_MAPPING_SOURCES: '/discovery/sources',
    DATA_STORES: '/discovery/stores',
    DOCUMENTS: '/documents',
    DOCUMENT_CHANGES: '/document-changes',
    DSAR_ACTION_ITEMS: '/subject-rights/action-items',
    DSAR_CONSUMER_SSO: '/subject-rights/consumer-sso',
    DSAR_FORMS: '/subject-rights/forms',
    DSAR_REPORTING: '/subject-rights/reporting',
    DSAR_REQUESTS: '/subject-rights/requests',
    FOLLOWING: '/following',
    GDPR: '/gdpr',
    INTEGRATIONS: '/integrations',
    LEGISLATION: '/legislation',
    LOGOUT: '/logout',
    NOTIFICATIONS: '/notifications',
    NOT_FOUND: '/not-found',
    ORGANIZATIONS: '/organizations',
    PREMIUM: '/premium',
    PRIVACY_ADVISOR: '/privacy-advisor',
    PRODUCTS: '/products',
    REPORTS: '/reports',
    REPORTS_CONSENT: '/reports/consent',
    REPORTS_CONSENT_V2: '/consent/dashboard',
    REPORTS_DATASUBJECT: '/reports/datasubject',
    REPORTS_DATASUBJECT_V2: '/subject-rights/reporting',
    REPORTS_VENDOR: '/reports/vendor',
    RESOURCES: '/resources',
    TRUSTHUB: '/trusthub',
    UC: '/unified-consent',
    UC_CONFIGS: '/unified-consent/configs',
    UC_DASHBOARD: '/unified-consent/dashboard',
    UC_INTEGRATIONS: '/unified-consent/integrations',
    UC_PRIVACY_PROTOCOLS: '/unified-consent/privacy-protocols',
    UPLOADS: '/uploads',
    USERS: '/users',
    VENDORS: '/vendors',
    WEBHOOKS: '/webhooks',

    REDIRECT_CONSENT_MANAGER: '/consent-manager',
};
